import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { FAIcon } from '@packages/ui-components';

type Props = {
  tooltipOn?: boolean;
  translation?: any;
  rightOffset: number;
  onClick: () => void;
};

export default function GetInTouchButton({ onClick, translation, rightOffset, tooltipOn }: Props) {
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const bgColor = 'rgba(0, 0, 0, 0.5)';
  const bgHoverColor = 'rgba(0, 0, 0, 0.7)';

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          position: 'absolute',
          top: '245px',
          transition: 'all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
          right: `${rightOffset}px`,
          zIndex: 1,
        }}
      >
        {tooltipOn && !hasBeenOpened && (
          <Chip
            sx={{
              background: bgColor,
              height: '32px !important',
              px: 1,

              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                },
                '50%': {
                  transform: 'scale(1.05)',
                },
                '100%': {
                  transform: 'scale(1)',
                },
              },
              animation: 'pulse 2s infinite',
            }}
            label={
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  color: 'white',
                }}
              >
                <Typography
                  sx={{
                    color: '#ffffff',
                  }}
                >
                  {translation?.getInTouchAppointmentTooltip || 'Get in touch'}
                </Typography>
                <FAIcon
                  icon="faCircleArrowRight"
                  style={{
                    fontSize: '1.2rem',
                  }}
                />
              </Stack>
            }
          />
        )}
        <Box>
          <IconButton
            sx={{
              background: bgColor,
              color: 'white',
              width: '40px',
              '&:hover': {
                background: bgHoverColor,
              },

              borderRadius: '10px 0 0 10px',
            }}
            onClick={() => {
              setHasBeenOpened(true);
              onClick();
            }}
          >
            <FAIcon icon="faEnvelope" />
          </IconButton>
        </Box>
      </Stack>
    </>
  );
}
